import React from "react";
import ChatLauncher from "./components/ChatLauncher";
import { useSelector } from "react-redux";
import { selectIsChatOpen } from "./Selectors/AssistantSelector";

const AIAssistant = ({ variant = "floating" }) => {
  const isChatOpen = useSelector(selectIsChatOpen);

  return <>{!isChatOpen && <ChatLauncher variant={variant} />}</>;
};

export default AIAssistant;